import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IComponentDetails } from '../interfaces/component-details.interface';
import { IConfig } from '../interfaces/config.interface';

@Injectable({
  providedIn: 'root'
})
export class PreviousComponentService {
  private previousComponentSource = new BehaviorSubject<IComponentDetails | null>(null);
  previousComponentToBeLoaded$ = this.previousComponentSource.asObservable();
  isBuyNow = false;

  constructor(@Inject('config') public SitecoreConfig: IConfig) {
    if(this.SitecoreConfig.Sitecore){
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow ? this.SitecoreConfig.Sitecore.isBuyNow : false;
    }
    
  }

  loadComponent(currentComponent: IComponentDetails) {
    this.previousComponentSource.next(currentComponent);
    if (this.isBuyNow && (window as any).ctaBuyNowReload != null) {
      /* istanbul ignore next */
      try {
        /* istanbul ignore next */
        (window as any).ctaBuyNowReload.reloadView();
      } catch (e) {
        /* istanbul ignore next */
        console.log(e);
      }
    }

  }

}
